module.exports = __webpack_public_path__ + "img/bg_3.jpg";